import AuthService from "../../service";
const service = {
  getService(page,search,sort_date,sort_branch) {
    return AuthService.get(`/service/services?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&sort_branch=${sort_branch}` +
      `&search=${search}`
    );
  },
  showService(id) {
    return AuthService.get("/service/services/" + id);
  },
  createService(data) {
    return AuthService.post("/service/services", data);
  },
  updateService(id, data) {
    return AuthService.put("/service/services/" + id, data);
  },
  deleteService(id) {
    return AuthService.delete("/service/services/" + id);
  },
  getServiceByBranch(branch_id) {
    return AuthService.get(`/service/service_by_branch?branch_id=${branch_id}`);
  },
  getServiceAll() {
    return AuthService.get("service/get_service_all");
  }
};
export default service;
